function webDriveDetect() {
  return navigator.webdriver;
}

export function useBotDetect() {
  const list = [
    webDriveDetect(),
  ];

  return {
    isBot: list.some(Boolean),
  };
}
